import React, { FC, useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BuySideInstance } from './BuySideInstance';
import { Button } from 'ncoded-component-library';
import PlusIcon from 'icons/Plus.icon';
import { SideDrawerRef } from 'router/subrouters/DataRoom/components/SideDrawer/SideDrawer.component';
import useCallbackRef from 'hooks/useCallbackRef';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import useMembers from '../../../../hooks/useMembers';
import AddGroupMember from '../AddGroupMember';

import './BuySideMobile.styles.scss';

type BuySideMobileProps = {
  onlyNew?: boolean;
};

const BuySideMobile: FC<BuySideMobileProps> = ({ onlyNew = false }) => {
  const { t } = useTranslation();
  const classes = classNames('buy-side-mobile');

  const [addMember, addMemberRef] = useCallbackRef<SideDrawerRef>(null);

  const { doesntHaveAccess } = useContext(DataRoomContext);

  const { buySideGroups, buySideMembers } = useMembers(onlyNew);

  const showAddGroupButton = !onlyNew;

  return (
    <div className={classes}>
      <div className="heading">
        <p className="name">{t('buySide')}</p>
        <p>
          {t('numOfMembers', { count: buySideMembers?.length })}{' '}
          {t('numOfGroups', { count: buySideGroups.length })}
        </p>

        {!doesntHaveAccess && showAddGroupButton && (
          <div className="actions">
            <Button icon={PlusIcon} onClick={() => addMember?.setOpen(true)}>
              {t('addMember')}
            </Button>
          </div>
        )}
      </div>

      {buySideGroups?.map((side, i) => (
        <BuySideInstance
          key={side._id}
          group={side}
          showEditGroupButton={!onlyNew}
          showDiscoveryFeature={i === 0}
        />
      ))}

      <AddGroupMember ref={addMemberRef} />
    </div>
  );
};

export default BuySideMobile;
